import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import JumpListPage from "./JumpListPage";
import LandingPage from "./LandingPage";
import LoginPage from "./LoginPage";
import App from "./App";
import AddJumpPage from "./AddJumpPage";
import PersonalPage from "./PersonalPage";
import RegisterPage from "./RegisterPage";
import ProtectedRoute from "./ProtectedRoute";
import SkydiverPublicProfile from "./SkydiverPublicProfile";
import PublicJump from "./PublicJump";
import ResetPassword from "./ResetPasswordPage";
import FlyListPage from "./windtunnel/FlyListPage";
import FlyPage from "./windtunnel/FlyPage";
import AddFlyPage from "./windtunnel/AddFlyPage";
import PublicFly from "./windtunnel/PublicFly";
import RegisterDetailsPage from "./RegisterDetailsPage";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>

        {/* ===== PUBLIC ROUTES ===== */}

        <Route
          path="/signup"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
            >
              <RegisterPage />
            </motion.div>
          }
        />
        <Route
          path="/register/details"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
            >
              <RegisterDetailsPage />
            </motion.div>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/login"
          element={
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
            >
              <LoginPage />
            </motion.div>
          }
        />

        <Route path="/u/:publicId" element={<SkydiverPublicProfile />} />
        <Route path="/jump/:id" element={<PublicJump />} />
        <Route path="/publicfly/:id" element={<PublicFly />} />

        {/* ===== PROTECTED ROUTES ===== */}

        <Route element={<ProtectedRoute />}>

          <Route
            path="/"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <LandingPage />
              </motion.div>
            }
          />

          <Route
            path="/jumps"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <JumpListPage />
              </motion.div>
            }
          />

          <Route
            path="/tunnel"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <FlyListPage />
              </motion.div>
            }
          />

          <Route
            path="/add-jump"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <AddJumpPage />
              </motion.div>
            }
          />
          <Route
            path="/add-session"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <AddFlyPage />
              </motion.div>
            }
          />

          <Route
            path="/personal"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <PersonalPage />
              </motion.div>
            }
          />

          <Route
            path="/app/:id"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <App />
              </motion.div>
            }
          />
          <Route
            path="/fly/:id"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              >
                <FlyPage />
              </motion.div>
            }
          />

        </Route>
      </Routes>
    </AnimatePresence>
  );
}

function StartPage() {
  return (
    <div className="p-4">
      <Router>
        <AnimatedRoutes />
      </Router>
    </div>
  );
}

export default StartPage;
